import {
  GetOfficeRnDConfig,
  ConnectOfficeRnDService,
  RemoveOfficeRnDService,
  ConnectOfficeRnDMembers,
  CheckRunningStatusOfficeRnDMembers,
  GetDeskworksConfig,
  GetDeskworksCenters,
  UpdateDeskworksCenters,
  ConnectDeskworksService,
  RemoveDeskworksService,
  ConnectDeskworksMembers,
  CheckRunningStatusDeskworksMembers,
  GetQuickbooksConfig,
  ConnectQuickbooksService,
  RemoveQuickbooksService,
  ConnectQuickbooksMembers,
  CheckRunningStatusQuickbooksMembers,
  GetNexudusConfig,
  ConnectNexudusService,
  RemoveNexudusService,
  ConnectNexudusMembers,
  CheckRunningStatusNexudusMembers,
  GetSystemIntegrationStatus,
  ToggleSystemIntegrationStatus,
} from '@/api/systems';

// eslint-disable-next-line import/no-cycle

export const getOfficeRnDConfig = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetOfficeRnDConfig()
    .then(res => {
      return res.officernd_configuration;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const connectOfficeRnDService = ({dispatch}, {data, successHandler, errorHandler}) => dispatch('CheckAuth', null, {root: true})
  .then(() => ConnectOfficeRnDService({data, successHandler, errorHandler})
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const connectOfficeRnDMembers = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => ConnectOfficeRnDMembers()
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

  export const checkRunningStatusOfficeRnDMembers = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => CheckRunningStatusOfficeRnDMembers(id)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });


export const removeOfficeRnDService = ({dispatch}, provider) => dispatch('CheckAuth', null, {root: true})
  .then(() => RemoveOfficeRnDService(provider)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });


  export const getDeskworksCenters = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetDeskworksCenters()
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });


  export const updateDeskworksCenters = ({dispatch} , data) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdateDeskworksCenters(data)
    .then(res => {
      return res;
    })
  )
  .catch(e => new Promise((resolve, reject) => {
    reject(e);
}))


  export const getDeskworksConfig = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetDeskworksConfig()
    .then(res => {
      return res.deskworks_configuration;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const connectDeskworksService = ({dispatch}, {data, successHandler, errorHandler}) => dispatch('CheckAuth', null, {root: true})
  .then(() => ConnectDeskworksService({data, successHandler, errorHandler})
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const connectDeskworksMembers = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => ConnectDeskworksMembers()
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const checkRunningStatusDeskworksMembers = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => CheckRunningStatusDeskworksMembers(id)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });


export const removeDeskworksService = ({dispatch}, provider) => dispatch('CheckAuth', null, {root: true})
  .then(() => RemoveDeskworksService(provider)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });


  export const getQuickbooksConfig = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetQuickbooksConfig()
    .then(res => {
      return res.quickbooks_configuration;
    }
  ))
  .catch((e) => {
    console.log(e);
  }
);

export const connectQuickbooksService = ({dispatch}, {data, successHandler, errorHandler}) => dispatch('CheckAuth', null, {root: true})
  .then(() => ConnectQuickbooksService({data, successHandler, errorHandler})
    .then(res => {
      return res;
    }
  ))
  .catch((e) => {
    console.log(e);
  }
);

export const connectQuickbooksMembers = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => ConnectQuickbooksMembers()
    .then(res => {
      return res;
    }
  ))
  .catch((e) => {
    console.log(e);
  }
);

export const checkRunningStatusQuickbooksMembers = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => CheckRunningStatusQuickbooksMembers(id)
    .then(res => {
      return res;
    }
  ))
  .catch((e) => {
    console.log(e);
  }
);

export const removeQuickbooksService = ({dispatch}, provider) => dispatch('CheckAuth', null, {root: true})
  .then(() => RemoveQuickbooksService(provider)
    .then(res => {
      return res;
    }
  ))
  .catch((e) => {
    console.log(e);
  }
);

export const getSystemIntegrationStatus = ({dispatch}, {integration}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetSystemIntegrationStatus({integration})
    .then(res => {
      return res;
    }
  ))
  .catch((e) => {
    console.log(e);
  }
);

export const toggleSystemIntegrationStatus = ({dispatch}, {integration, status}) => dispatch('CheckAuth', null, {root: true})
  .then(() => ToggleSystemIntegrationStatus({integration, status})
    .then(res => {
      return res;
    }
  ))
  .catch((e) => {
    console.log(e);
  }
);


export const getNexudusConfig = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
.then(() => GetNexudusConfig()
  .then(res => {
    return res.nexudus_configuration;
  })
)
.catch((e) => {
  console.log(e);
});

export const connectNexudusService = ({dispatch}, {data, successHandler, errorHandler}) => dispatch('CheckAuth', null, {root: true})
.then(() => ConnectNexudusService({data, successHandler, errorHandler})
  .then(res => {
    return res;
  })
)
.catch((e) => {
  console.log(e);
});

export const connectNexudusMembers = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
.then(() => ConnectNexudusMembers()
  .then(res => {
    return res;
  })
)
.catch((e) => {
  console.log(e);
});

export const checkRunningStatusNexudusMembers = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
.then(() => CheckRunningStatusNexudusMembers(id)
  .then(res => {
    return res;
  })
)
.catch((e) => {
  console.log(e);
});


export const removeNexudusService = ({dispatch}, provider) => dispatch('CheckAuth', null, {root: true})
.then(() => RemoveNexudusService(provider)
  .then(res => {
    return res;
  })
)
.catch((e) => {
  console.log(e);
});
